// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wizzy — cost estimation page */

.cost-estimation-container {
  display: grid;
  grid-template-columns: 320px 1fr;
  min-height: 100vh;
  gap: 0;
  background: var(--wz-bg);
}

.cost-estimation-sidebar {
  background: var(--wz-card);
  border-right: 1px solid var(--wz-line);
  overflow-y: auto;
  height: 100vh;
  position: sticky;
  top: 0;
  box-shadow: 1px 0 0 rgba(18, 22, 15, 0.02);
}

.cost-estimation-main {
  display: flex;
  flex-direction: column;
  background: var(--wz-card);
  min-height: 100vh;
}

.cost-estimation-header {
  padding: 18px 28px;
  border-bottom: 1px solid var(--wz-line);
  background: var(--wz-card);
  position: sticky;
  top: 0;
  z-index: 5;
}

.cost-estimation-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg,
    var(--wz-green) 0%,
    var(--wz-green-strong) 38%,
    rgba(182, 206, 59, 0.12) 100%);
  pointer-events: none;
}

.cost-estimation-header h1 {
  margin: 0;
  font-size: 21px;
  font-weight: 600;
  color: var(--wz-ink);
}

.cost-estimation-header-meta {
  margin-top: 8px;
  font-size: 12.5px;
  color: var(--wz-text-2);
  display: flex;
  gap: 8px 18px;
  flex-wrap: wrap;
  font-variant-numeric: tabular-nums;
}

.cost-estimation-content {
  flex: 1 1;
  padding: 24px 28px;
  overflow: auto;
}

/* Footer (skin — layout stays inline in EstimationFooter.jsx) */
.cost-estimation-footer {
  background: var(--wz-card);
  border-top: 1px solid var(--wz-line);
  box-shadow: 0 -4px 24px rgba(18, 22, 15, 0.06);
}

.wz-total-group {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
}

.wz-total-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--wz-text-2);
}

.wz-total-value {
  font-family: var(--wz-font-display);
  font-size: 16px;
  color: var(--wz-ink);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
}

.wz-total-main .wz-total-value {
  font-size: 20px;
  padding: 2px 12px;
  background: var(--wz-green-tint);
  border: 1px solid var(--wz-green-tint-2);
  border-radius: 8px;
}

/* Table Styles */
.estimation-table-wrapper {
  background: var(--wz-card);
}

.estimation-table-wrapper .ant-table {
  font-size: 12px;
}

.estimation-table-wrapper .ant-table-thead > tr > th {
  background: #f4f6ec;
  font-weight: 600;
  font-size: 11px;
  padding: 8px 12px;
  position: sticky;
  top: 0;
  z-index: 3;
}

.estimation-table-wrapper .ant-table-tbody > tr > td {
  padding: 6px 12px;
  font-size: 12px;
  vertical-align: middle;
}

/* Parent Row Styles */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent {
  background: var(--wz-bg-2);
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent:hover {
  background: var(--wz-green-tint-2) !important;
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent > td {
  background: var(--wz-bg-2);
  font-weight: 500;
}

/* Leaf Row Styles */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-leaf {
  background: var(--wz-card);
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-leaf:hover {
  background: var(--wz-green-tint) !important;
}

/* Row Level Indentation - Enhanced Backgrounds */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-1 {
  background: var(--wz-bg-2);
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-1.estimation-row-leaf {
  background: var(--wz-card);
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-2 {
  background: #f4f6ec;
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-2.estimation-row-leaf {
  background: #fbfcf7;
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-3 {
  background: #f8f9f2;
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-3.estimation-row-leaf {
  background: var(--wz-card);
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-4 {
  background: #fbfcf7;
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-4.estimation-row-leaf {
  background: #fbfcf7;
}

/* Level 1 Parent Rows - Most Prominent */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-1.estimation-row-parent > td {
  font-weight: 700;
  font-size: 13px;
  background: var(--wz-bg-2);
  border-top: 2px solid var(--wz-ink-2);
  border-bottom: 1px solid var(--wz-line-2);
}

/* Level 2 Parent Rows */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-2.estimation-row-parent > td {
  font-weight: 600;
  font-size: 12px;
  background: #f4f6ec;
  border-top: 1px solid var(--wz-line-2);
}

/* Level 3 Parent Rows */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-3.estimation-row-parent > td {
  font-weight: 600;
  font-size: 12px;
  background: #f8f9f2;
}

/* Level 4 Parent Rows */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-4.estimation-row-parent > td {
  font-weight: 500;
  font-size: 12px;
  background: #fbfcf7;
}

/* Summary Rows (deprecated - using parent/leaf classes now) */
.estimation-table-wrapper .ant-table-tbody > tr.summary-row {
  background: var(--wz-bg-2);
  font-weight: 600;
}

.estimation-table-wrapper .ant-table-tbody > tr.summary-row > td {
  background: var(--wz-bg-2);
}

/* Input Styles */
.estimation-table-wrapper .ant-input-number {
  width: 100%;
}

.estimation-table-wrapper .ant-input-number-input {
  text-align: right;
  font-size: 12px;
  padding: 2px 8px;
  font-variant-numeric: tabular-nums;
}

.estimation-table-wrapper .ant-select {
  font-size: 12px;
}

.estimation-table-wrapper .ant-select-selection-item {
  font-size: 12px;
}

/* Disabled Input Styles for Parent Rows */
.estimation-table-wrapper .ant-input-number-disabled {
  background: transparent;
  border: none;
  color: var(--wz-text-3);
}

/* Manual vs Suggested Value Styling */
.manual-input {
  font-style: normal;
  color: var(--wz-ink);
  font-weight: 500;
}

.suggested-input {
  font-style: italic;
  color: var(--wz-text-2);
}

/* Compact Table */
.estimation-table-wrapper .ant-table-small .ant-table-tbody > tr > td {
  padding: 4px 8px;
}

.estimation-table-wrapper .ant-table-small .ant-table-thead > tr > th {
  padding: 6px 8px;
}

/* Total Column Highlight */
.estimation-table-wrapper .ant-table-tbody > tr > td:last-child {
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

/* Parent Row Total Column - Extra Emphasis */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent > td:last-child {
  font-weight: 700;
  font-size: 14px;
}

/* Level 1 Total - Most Emphasis */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-1.estimation-row-parent > td:last-child {
  font-weight: 700;
  font-size: 15px;
  background: var(--wz-green-tint-2);
}

/* Info Icon */
.estimation-table-wrapper .anticon-info-circle {
  font-size: 14px;
}

.estimation-table-wrapper .anticon-info-circle:hover {
  color: var(--wz-green-deep);
}

/* Lock Icon for Parent Rows */
.estimation-table-wrapper .anticon-lock {
  color: var(--wz-text-3);
  font-size: 12px;
}

/* Hierarchy Visual Indicators */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent > td:first-child::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 100%;
  background: var(--wz-green);
  position: absolute;
  left: 0;
  top: 0;
}

/* Striped Rows for Better Readability */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-leaf:nth-child(even) {
  background: #fbfcf7;
}

.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-leaf:nth-child(even):hover {
  background: var(--wz-green-tint) !important;
}

/* Fixed Column Shadows */
.estimation-table-wrapper .ant-table-cell-fix-left,
.estimation-table-wrapper .ant-table-cell-fix-right {
  background: inherit !important;
}

.estimation-table-wrapper .ant-table-cell-fix-left-last::after {
  box-shadow: inset 10px 0 8px -8px rgba(18, 22, 15, 0.08);
}

.estimation-table-wrapper .ant-table-cell-fix-right-first::after {
  box-shadow: inset -10px 0 8px -8px rgba(18, 22, 15, 0.08);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .cost-estimation-container {
    grid-template-columns: 280px 1fr;
  }
}

@media (max-width: 992px) {
  .cost-estimation-container {
    grid-template-columns: 1fr;
  }

  .cost-estimation-sidebar {
    position: static;
    height: auto;
    border-right: none;
    border-bottom: 1px solid var(--wz-line);
  }
}

/* Footer Responsive */
@media (max-width: 768px) {
  .cost-estimation-footer {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start !important;
  }

  .cost-estimation-footer > div {
    width: 100%;
  }

  .cost-estimation-footer > div:last-child {
    justify-content: flex-start;
  }
}

/* Loading State */
.estimation-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  flex-direction: column;
  gap: 16px;
}

.estimation-loading-text {
  color: var(--wz-text-2);
  font-size: 14px;
}

/* Empty State */
.estimation-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  flex-direction: column;
  gap: 16px;
  color: var(--wz-text-3);
}

.estimation-empty-icon {
  font-size: 48px;
  color: var(--wz-line-2);
}

.estimation-empty-text {
  font-size: 16px;
  color: var(--wz-text-2);
}

/* Highlight accent color */
.estimation-accent {
  color: var(--wz-green-deep);
}

/* Table cell alignment helpers */
.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

/* Inclusion Toggle Button Styles */
.estimation-table-wrapper .ant-table-thead > tr > th:first-child {
  text-align: center;
  background: #f4f6ec;
}

/* Hover Effects for Interactive Elements */
.estimation-table-wrapper .ant-table-tbody > tr > td:first-child span {
  transition: all 0.2s ease;
}

.estimation-table-wrapper .ant-table-tbody > tr > td:first-child span:hover {
  transform: scale(1.2);
}

/* Selection Highlight */
.estimation-table-wrapper .ant-table-tbody > tr.ant-table-row-selected > td {
  background: var(--wz-green-tint-2);
}

/* NEW: Master Project Selector Section Styles */
.master-project-selector {
  margin-top: 24px;
  padding: 16px;
  background: var(--wz-card);
  border: 1px solid var(--wz-line);
  border-radius: var(--wz-r-md);
}

.master-project-selector-label {
  display: block;
  font-size: 13px;
  color: var(--wz-ink);
  margin-bottom: 8px;
  font-weight: 600;
}

.master-project-selector-hint {
  margin-top: 6px;
  font-size: 11px;
  color: var(--wz-text-3);
  font-style: italic;
}

/* NEW: CSV Upload Section Styles */
.csv-upload-section {
  margin-top: 16px;
  padding: 16px;
  background: var(--wz-card);
  border: 1px solid var(--wz-line);
  border-radius: var(--wz-r-md);
}

.csv-upload-label {
  display: block;
  font-size: 13px;
  color: var(--wz-ink);
  margin-bottom: 8px;
  font-weight: 600;
}

.csv-upload-hint {
  font-size: 11px;
  color: var(--wz-text-3);
  font-style: italic;
  margin-bottom: 8px;
}

/* NEW: CSV Upload Error Display */
.csv-upload-errors {
  margin-top: 12px;
}

.csv-upload-errors .ant-collapse-ghost {
  background: #fff2e8;
  border: 1px solid #ffbb96;
  border-radius: var(--wz-r-sm);
}

.csv-upload-errors .ant-collapse-header {
  padding: 8px 12px;
}

.csv-upload-errors .ant-collapse-content-box {
  padding: 8px 12px;
  max-height: 200px;
  overflow-y: auto;
}

.csv-error-item {
  padding: 4px 0;
  font-size: 11px;
  color: #d46b08;
  border-bottom: 1px solid #ffe7ba;
}

.csv-error-item:last-child {
  border-bottom: none;
}

.csv-error-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.csv-error-icon {
  color: #fa8c16;
}

.csv-error-text {
  font-size: 12px;
  font-weight: 500;
  color: #d46b08;
}

/* NEW: Inconsistency Warning Styles */
.estimation-row-inconsistent {
  position: relative;
}

.estimation-row-inconsistent > td {
  background-color: #fff2e8 !important;
}

.estimation-row-inconsistent:hover > td {
  background-color: #ffe7ba !important;
}

/* Enhanced border for inconsistent rows */
.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-inconsistent > td:first-child {
  border-left: 3px solid #ff4d4f;
}

/* Warning icon styling */
.estimation-table-wrapper .anticon-warning {
  color: #ff4d4f;
  font-size: 12px;
}

/* Print Styles */
@media print {
  .cost-estimation-sidebar,
  .cost-estimation-header button,
  .estimation-table-wrapper .ant-table-tbody > tr > td:first-child {
    display: none;
  }

  .cost-estimation-container {
    grid-template-columns: 1fr;
  }

  .estimation-table-wrapper .ant-table {
    font-size: 10px;
  }
}

/* Sidebar Section Spacing */
.cost-estimation-sidebar > div {
  padding: 20px;
}

/* Sidebar heading */
.cost-estimation-sidebar h2 {
  font-size: 15px !important;
  letter-spacing: -0.01em;
}

/* Ensure proper spacing between sidebar sections */
.cost-estimation-sidebar .master-project-selector + .csv-upload-section {
  margin-top: 16px;
}

/* Project dropdown - wider to accommodate new label format */
.estimation-table-wrapper .ant-select-dropdown {
  min-width: 400px !important;
}

.estimation-table-wrapper .ant-select-item-option-content {
  white-space: normal;
  line-height: 1.4;
  padding: 4px 0;
}

/* Tooltip styling for better readability */
.ant-tooltip-inner {
  max-width: 300px;
}

/* ---------------------------------------------------------------------------
   Collapsible hierarchy: toolbar, expander and group roll-up badges.
   Additive only — the table still renders <tr>/<td>, so every rule above
   keeps applying unchanged.
   --------------------------------------------------------------------------- */

.estimation-table-wrapper .estimation-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 8px 10px;
  margin-bottom: 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
}

.estimation-table-wrapper .estimation-toolbar-count {
  margin-left: auto;
  font-size: 12px;
  color: #8c8c8c;
  white-space: nowrap;
}

.estimation-table-wrapper .estimation-expander,
.estimation-table-wrapper .estimation-expander-spacer {
  display: inline-block;
  flex: 0 0 14px;
  width: 14px;
  text-align: center;
  font-family: Menlo, Consolas, monospace;
  font-size: 13px;
  line-height: 1;
  font-weight: 700;
  -webkit-user-select: none;
          user-select: none;
}

.estimation-table-wrapper .estimation-expander {
  cursor: pointer;
  color: #1890ff;
  transition: color 0.15s ease;
}

.estimation-table-wrapper .estimation-expander:hover {
  color: #40a9ff;
}


.estimation-table-wrapper .estimation-group-badges {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding-left: 6px;
  white-space: nowrap;
}

.estimation-table-wrapper .estimation-badge {
  display: inline-block;
  padding: 0 5px;
  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  color: #595959;
  background: #f0f0f0;
  border-radius: 3px;
}

.estimation-table-wrapper .estimation-badge.is-filled {
  color: #237804;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  line-height: 14px;
}

.estimation-table-wrapper .estimation-badge.is-empty {
  color: #bfbfbf;
  background: #fafafa;
}

.estimation-table-wrapper .estimation-more {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  margin-top: 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
}

.estimation-table-wrapper .estimation-more-hint {
  font-size: 12px;
  color: #8c8c8c;
}
`, "",{"version":3,"sources":["webpack://./src/components/CostEstimation/CostEstimation.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,MAAM;EACN,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;kCAGgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,iDAAiD;AACjD;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,yBAAyB;AACzB;;EAEE,8BAA8B;AAChC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,sBAAsB;AACtB;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;EACzC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kCAAkC;EACpC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;AACpC;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;;;;gFAIgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* Wizzy — cost estimation page */\n\n.cost-estimation-container {\n  display: grid;\n  grid-template-columns: 320px 1fr;\n  min-height: 100vh;\n  gap: 0;\n  background: var(--wz-bg);\n}\n\n.cost-estimation-sidebar {\n  background: var(--wz-card);\n  border-right: 1px solid var(--wz-line);\n  overflow-y: auto;\n  height: 100vh;\n  position: sticky;\n  top: 0;\n  box-shadow: 1px 0 0 rgba(18, 22, 15, 0.02);\n}\n\n.cost-estimation-main {\n  display: flex;\n  flex-direction: column;\n  background: var(--wz-card);\n  min-height: 100vh;\n}\n\n.cost-estimation-header {\n  padding: 18px 28px;\n  border-bottom: 1px solid var(--wz-line);\n  background: var(--wz-card);\n  position: sticky;\n  top: 0;\n  z-index: 5;\n}\n\n.cost-estimation-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg,\n    var(--wz-green) 0%,\n    var(--wz-green-strong) 38%,\n    rgba(182, 206, 59, 0.12) 100%);\n  pointer-events: none;\n}\n\n.cost-estimation-header h1 {\n  margin: 0;\n  font-size: 21px;\n  font-weight: 600;\n  color: var(--wz-ink);\n}\n\n.cost-estimation-header-meta {\n  margin-top: 8px;\n  font-size: 12.5px;\n  color: var(--wz-text-2);\n  display: flex;\n  gap: 8px 18px;\n  flex-wrap: wrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.cost-estimation-content {\n  flex: 1;\n  padding: 24px 28px;\n  overflow: auto;\n}\n\n/* Footer (skin — layout stays inline in EstimationFooter.jsx) */\n.cost-estimation-footer {\n  background: var(--wz-card);\n  border-top: 1px solid var(--wz-line);\n  box-shadow: 0 -4px 24px rgba(18, 22, 15, 0.06);\n}\n\n.wz-total-group {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.wz-total-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--wz-text-2);\n}\n\n.wz-total-value {\n  font-family: var(--wz-font-display);\n  font-size: 16px;\n  color: var(--wz-ink);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.01em;\n}\n\n.wz-total-main .wz-total-value {\n  font-size: 20px;\n  padding: 2px 12px;\n  background: var(--wz-green-tint);\n  border: 1px solid var(--wz-green-tint-2);\n  border-radius: 8px;\n}\n\n/* Table Styles */\n.estimation-table-wrapper {\n  background: var(--wz-card);\n}\n\n.estimation-table-wrapper .ant-table {\n  font-size: 12px;\n}\n\n.estimation-table-wrapper .ant-table-thead > tr > th {\n  background: #f4f6ec;\n  font-weight: 600;\n  font-size: 11px;\n  padding: 8px 12px;\n  position: sticky;\n  top: 0;\n  z-index: 3;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr > td {\n  padding: 6px 12px;\n  font-size: 12px;\n  vertical-align: middle;\n}\n\n/* Parent Row Styles */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent {\n  background: var(--wz-bg-2);\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent:hover {\n  background: var(--wz-green-tint-2) !important;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent > td {\n  background: var(--wz-bg-2);\n  font-weight: 500;\n}\n\n/* Leaf Row Styles */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-leaf {\n  background: var(--wz-card);\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-leaf:hover {\n  background: var(--wz-green-tint) !important;\n}\n\n/* Row Level Indentation - Enhanced Backgrounds */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-1 {\n  background: var(--wz-bg-2);\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-1.estimation-row-leaf {\n  background: var(--wz-card);\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-2 {\n  background: #f4f6ec;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-2.estimation-row-leaf {\n  background: #fbfcf7;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-3 {\n  background: #f8f9f2;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-3.estimation-row-leaf {\n  background: var(--wz-card);\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-4 {\n  background: #fbfcf7;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-4.estimation-row-leaf {\n  background: #fbfcf7;\n}\n\n/* Level 1 Parent Rows - Most Prominent */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-1.estimation-row-parent > td {\n  font-weight: 700;\n  font-size: 13px;\n  background: var(--wz-bg-2);\n  border-top: 2px solid var(--wz-ink-2);\n  border-bottom: 1px solid var(--wz-line-2);\n}\n\n/* Level 2 Parent Rows */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-2.estimation-row-parent > td {\n  font-weight: 600;\n  font-size: 12px;\n  background: #f4f6ec;\n  border-top: 1px solid var(--wz-line-2);\n}\n\n/* Level 3 Parent Rows */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-3.estimation-row-parent > td {\n  font-weight: 600;\n  font-size: 12px;\n  background: #f8f9f2;\n}\n\n/* Level 4 Parent Rows */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-4.estimation-row-parent > td {\n  font-weight: 500;\n  font-size: 12px;\n  background: #fbfcf7;\n}\n\n/* Summary Rows (deprecated - using parent/leaf classes now) */\n.estimation-table-wrapper .ant-table-tbody > tr.summary-row {\n  background: var(--wz-bg-2);\n  font-weight: 600;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.summary-row > td {\n  background: var(--wz-bg-2);\n}\n\n/* Input Styles */\n.estimation-table-wrapper .ant-input-number {\n  width: 100%;\n}\n\n.estimation-table-wrapper .ant-input-number-input {\n  text-align: right;\n  font-size: 12px;\n  padding: 2px 8px;\n  font-variant-numeric: tabular-nums;\n}\n\n.estimation-table-wrapper .ant-select {\n  font-size: 12px;\n}\n\n.estimation-table-wrapper .ant-select-selection-item {\n  font-size: 12px;\n}\n\n/* Disabled Input Styles for Parent Rows */\n.estimation-table-wrapper .ant-input-number-disabled {\n  background: transparent;\n  border: none;\n  color: var(--wz-text-3);\n}\n\n/* Manual vs Suggested Value Styling */\n.manual-input {\n  font-style: normal;\n  color: var(--wz-ink);\n  font-weight: 500;\n}\n\n.suggested-input {\n  font-style: italic;\n  color: var(--wz-text-2);\n}\n\n/* Compact Table */\n.estimation-table-wrapper .ant-table-small .ant-table-tbody > tr > td {\n  padding: 4px 8px;\n}\n\n.estimation-table-wrapper .ant-table-small .ant-table-thead > tr > th {\n  padding: 6px 8px;\n}\n\n/* Total Column Highlight */\n.estimation-table-wrapper .ant-table-tbody > tr > td:last-child {\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Parent Row Total Column - Extra Emphasis */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent > td:last-child {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n/* Level 1 Total - Most Emphasis */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-level-1.estimation-row-parent > td:last-child {\n  font-weight: 700;\n  font-size: 15px;\n  background: var(--wz-green-tint-2);\n}\n\n/* Info Icon */\n.estimation-table-wrapper .anticon-info-circle {\n  font-size: 14px;\n}\n\n.estimation-table-wrapper .anticon-info-circle:hover {\n  color: var(--wz-green-deep);\n}\n\n/* Lock Icon for Parent Rows */\n.estimation-table-wrapper .anticon-lock {\n  color: var(--wz-text-3);\n  font-size: 12px;\n}\n\n/* Hierarchy Visual Indicators */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-parent > td:first-child::before {\n  content: '';\n  display: inline-block;\n  width: 3px;\n  height: 100%;\n  background: var(--wz-green);\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n/* Striped Rows for Better Readability */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-leaf:nth-child(even) {\n  background: #fbfcf7;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-leaf:nth-child(even):hover {\n  background: var(--wz-green-tint) !important;\n}\n\n/* Fixed Column Shadows */\n.estimation-table-wrapper .ant-table-cell-fix-left,\n.estimation-table-wrapper .ant-table-cell-fix-right {\n  background: inherit !important;\n}\n\n.estimation-table-wrapper .ant-table-cell-fix-left-last::after {\n  box-shadow: inset 10px 0 8px -8px rgba(18, 22, 15, 0.08);\n}\n\n.estimation-table-wrapper .ant-table-cell-fix-right-first::after {\n  box-shadow: inset -10px 0 8px -8px rgba(18, 22, 15, 0.08);\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .cost-estimation-container {\n    grid-template-columns: 280px 1fr;\n  }\n}\n\n@media (max-width: 992px) {\n  .cost-estimation-container {\n    grid-template-columns: 1fr;\n  }\n\n  .cost-estimation-sidebar {\n    position: static;\n    height: auto;\n    border-right: none;\n    border-bottom: 1px solid var(--wz-line);\n  }\n}\n\n/* Footer Responsive */\n@media (max-width: 768px) {\n  .cost-estimation-footer {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start !important;\n  }\n\n  .cost-estimation-footer > div {\n    width: 100%;\n  }\n\n  .cost-estimation-footer > div:last-child {\n    justify-content: flex-start;\n  }\n}\n\n/* Loading State */\n.estimation-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.estimation-loading-text {\n  color: var(--wz-text-2);\n  font-size: 14px;\n}\n\n/* Empty State */\n.estimation-empty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  flex-direction: column;\n  gap: 16px;\n  color: var(--wz-text-3);\n}\n\n.estimation-empty-icon {\n  font-size: 48px;\n  color: var(--wz-line-2);\n}\n\n.estimation-empty-text {\n  font-size: 16px;\n  color: var(--wz-text-2);\n}\n\n/* Highlight accent color */\n.estimation-accent {\n  color: var(--wz-green-deep);\n}\n\n/* Table cell alignment helpers */\n.text-right {\n  text-align: right;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n/* Inclusion Toggle Button Styles */\n.estimation-table-wrapper .ant-table-thead > tr > th:first-child {\n  text-align: center;\n  background: #f4f6ec;\n}\n\n/* Hover Effects for Interactive Elements */\n.estimation-table-wrapper .ant-table-tbody > tr > td:first-child span {\n  transition: all 0.2s ease;\n}\n\n.estimation-table-wrapper .ant-table-tbody > tr > td:first-child span:hover {\n  transform: scale(1.2);\n}\n\n/* Selection Highlight */\n.estimation-table-wrapper .ant-table-tbody > tr.ant-table-row-selected > td {\n  background: var(--wz-green-tint-2);\n}\n\n/* NEW: Master Project Selector Section Styles */\n.master-project-selector {\n  margin-top: 24px;\n  padding: 16px;\n  background: var(--wz-card);\n  border: 1px solid var(--wz-line);\n  border-radius: var(--wz-r-md);\n}\n\n.master-project-selector-label {\n  display: block;\n  font-size: 13px;\n  color: var(--wz-ink);\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.master-project-selector-hint {\n  margin-top: 6px;\n  font-size: 11px;\n  color: var(--wz-text-3);\n  font-style: italic;\n}\n\n/* NEW: CSV Upload Section Styles */\n.csv-upload-section {\n  margin-top: 16px;\n  padding: 16px;\n  background: var(--wz-card);\n  border: 1px solid var(--wz-line);\n  border-radius: var(--wz-r-md);\n}\n\n.csv-upload-label {\n  display: block;\n  font-size: 13px;\n  color: var(--wz-ink);\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.csv-upload-hint {\n  font-size: 11px;\n  color: var(--wz-text-3);\n  font-style: italic;\n  margin-bottom: 8px;\n}\n\n/* NEW: CSV Upload Error Display */\n.csv-upload-errors {\n  margin-top: 12px;\n}\n\n.csv-upload-errors .ant-collapse-ghost {\n  background: #fff2e8;\n  border: 1px solid #ffbb96;\n  border-radius: var(--wz-r-sm);\n}\n\n.csv-upload-errors .ant-collapse-header {\n  padding: 8px 12px;\n}\n\n.csv-upload-errors .ant-collapse-content-box {\n  padding: 8px 12px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.csv-error-item {\n  padding: 4px 0;\n  font-size: 11px;\n  color: #d46b08;\n  border-bottom: 1px solid #ffe7ba;\n}\n\n.csv-error-item:last-child {\n  border-bottom: none;\n}\n\n.csv-error-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.csv-error-icon {\n  color: #fa8c16;\n}\n\n.csv-error-text {\n  font-size: 12px;\n  font-weight: 500;\n  color: #d46b08;\n}\n\n/* NEW: Inconsistency Warning Styles */\n.estimation-row-inconsistent {\n  position: relative;\n}\n\n.estimation-row-inconsistent > td {\n  background-color: #fff2e8 !important;\n}\n\n.estimation-row-inconsistent:hover > td {\n  background-color: #ffe7ba !important;\n}\n\n/* Enhanced border for inconsistent rows */\n.estimation-table-wrapper .ant-table-tbody > tr.estimation-row-inconsistent > td:first-child {\n  border-left: 3px solid #ff4d4f;\n}\n\n/* Warning icon styling */\n.estimation-table-wrapper .anticon-warning {\n  color: #ff4d4f;\n  font-size: 12px;\n}\n\n/* Print Styles */\n@media print {\n  .cost-estimation-sidebar,\n  .cost-estimation-header button,\n  .estimation-table-wrapper .ant-table-tbody > tr > td:first-child {\n    display: none;\n  }\n\n  .cost-estimation-container {\n    grid-template-columns: 1fr;\n  }\n\n  .estimation-table-wrapper .ant-table {\n    font-size: 10px;\n  }\n}\n\n/* Sidebar Section Spacing */\n.cost-estimation-sidebar > div {\n  padding: 20px;\n}\n\n/* Sidebar heading */\n.cost-estimation-sidebar h2 {\n  font-size: 15px !important;\n  letter-spacing: -0.01em;\n}\n\n/* Ensure proper spacing between sidebar sections */\n.cost-estimation-sidebar .master-project-selector + .csv-upload-section {\n  margin-top: 16px;\n}\n\n/* Project dropdown - wider to accommodate new label format */\n.estimation-table-wrapper .ant-select-dropdown {\n  min-width: 400px !important;\n}\n\n.estimation-table-wrapper .ant-select-item-option-content {\n  white-space: normal;\n  line-height: 1.4;\n  padding: 4px 0;\n}\n\n/* Tooltip styling for better readability */\n.ant-tooltip-inner {\n  max-width: 300px;\n}\n\n/* ---------------------------------------------------------------------------\n   Collapsible hierarchy: toolbar, expander and group roll-up badges.\n   Additive only — the table still renders <tr>/<td>, so every rule above\n   keeps applying unchanged.\n   --------------------------------------------------------------------------- */\n\n.estimation-table-wrapper .estimation-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 8px 10px;\n  margin-bottom: 8px;\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  border-radius: 6px;\n}\n\n.estimation-table-wrapper .estimation-toolbar-count {\n  margin-left: auto;\n  font-size: 12px;\n  color: #8c8c8c;\n  white-space: nowrap;\n}\n\n.estimation-table-wrapper .estimation-expander,\n.estimation-table-wrapper .estimation-expander-spacer {\n  display: inline-block;\n  flex: 0 0 14px;\n  width: 14px;\n  text-align: center;\n  font-family: Menlo, Consolas, monospace;\n  font-size: 13px;\n  line-height: 1;\n  font-weight: 700;\n  user-select: none;\n}\n\n.estimation-table-wrapper .estimation-expander {\n  cursor: pointer;\n  color: #1890ff;\n  transition: color 0.15s ease;\n}\n\n.estimation-table-wrapper .estimation-expander:hover {\n  color: #40a9ff;\n}\n\n\n.estimation-table-wrapper .estimation-group-badges {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: auto;\n  padding-left: 6px;\n  white-space: nowrap;\n}\n\n.estimation-table-wrapper .estimation-badge {\n  display: inline-block;\n  padding: 0 5px;\n  font-size: 10px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #595959;\n  background: #f0f0f0;\n  border-radius: 3px;\n}\n\n.estimation-table-wrapper .estimation-badge.is-filled {\n  color: #237804;\n  background: #f6ffed;\n  border: 1px solid #b7eb8f;\n  line-height: 14px;\n}\n\n.estimation-table-wrapper .estimation-badge.is-empty {\n  color: #bfbfbf;\n  background: #fafafa;\n}\n\n.estimation-table-wrapper .estimation-more {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  margin-top: 8px;\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  border-radius: 6px;\n}\n\n.estimation-table-wrapper .estimation-more-hint {\n  font-size: 12px;\n  color: #8c8c8c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
